import {
   PDFDownloadLink,
   PDFViewer,
   Document,
   Page,
   Image,
   Text,
   View,
   StyleSheet,
   Link,
   Font,
} from '@react-pdf/renderer';
import parse from 'html-react-parser';
import { Html } from 'react-pdf-html';
export const CatalogShopGridPDF = (styles,settings,row,rowIndex) => (
   <View key={rowIndex} style={styles.rowContainer}> {/* Row container for each row */}
                          {/* Loop through each product in the row */}
                          {row.map((product, productIndex) => (
                            <View key={productIndex} style={styles.contentContainermain}>
                              <View>
                                {settings.setting?.gmwcp_shop_show_hide?.includes('images') &&
                                  product.images && product.images.full && (
                                    <Image
                                      src={product.images.full}
                                      alt={product.name}
                                      style={styles.image}
                                    />
                                  )}
                                {settings.setting?.gmwcp_shop_show_hide?.includes('gallery') && (
                                  <View style={styles.galleryImagesContainer}>
                                    {product.gallery_images?.map((image, imgIndex) => (
                                      <Image
                                        key={imgIndex}
                                        src={image.src}
                                        alt={image.alt}
                                        style={styles.galleryImage}
                                      />
                                    ))}
                                  </View>
                                )}

                                {settings.setting?.gmwcp_shop_show_hide?.includes('title') && (
                                  <Text style={styles.productName}>{product.name}</Text>
                                )}
                                {settings.setting?.gmwcp_shop_show_hide?.includes('short_desc') && (
                                  <Text>{parse(product.short_description)}</Text>
                                )}
                                {settings.setting?.gmwcp_shop_show_hide?.includes('read_more') && (
                                  <Link src={product.permalink} style={styles.productLink}>
                                    {settings.setting?.gmpcp_trasnlation_read_more||''}{' '}
                                  </Link>
                                )}
                                {settings.setting?.gmwcp_shop_show_hide?.includes('sku') && (
                                  <Text style={styles.contentpart}>
                                    <Text style={styles.boldLabel}>
                                      {settings.setting?.gmpcp_trasnlation_sku||''}{' '}
                                    </Text>
                                    {product.sku}
                                  </Text>
                                )}
                                {settings.setting?.gmwcp_shop_show_hide?.includes('price') && (
                                  <Text style={styles.contentpart}>
                                    <Text style={styles.boldLabel}>
                                      {settings.setting?.gmpcp_trasnlation_price||''}{' '}
                                    </Text>
                                    {product.price}
                                  </Text>
                                )}
                                {settings.setting?.gmwcp_shop_show_hide?.includes('stock_status') && (
                                  <Text style={styles.contentpart}>
                                    <Text style={styles.boldLabel}>
                                      {settings.setting?.gmpcp_trasnlation_stock||''}{' '}
                                    </Text>
                                    {product.stock_status}
                                  </Text>
                                )}
                                {settings.setting?.gmwcp_shop_show_hide?.includes('categories') && (
                                  <Text style={styles.contentpart}>
                                    <Text style={styles.boldLabel}>
                                      {settings.setting?.gmpcp_trasnlation_categories||''}{' '}
                                    </Text>
                                    {product.producat_cat.join(', ')}
                                  </Text>
                                )}
                                {settings.setting?.gmwcp_shop_show_hide?.includes('tags') && (
                                  <Text style={styles.contentpart}>
                                    <Text style={styles.boldLabel}>
                                      {settings.setting?.gmpcp_trasnlation_tags||''}{' '}
                                    </Text>
                                    {product.producat_tag.join(', ')}
                                  </Text>
                                )}

                                {product.gmwcp_custom_field && 
                                         Object.keys(product.gmwcp_custom_field).map((key, index) => {
                                           const gmwcp_custom_field = product.gmwcp_custom_field[key];
                                          console.log(key);
                                           if (settings.setting?.gmwcp_shop_show_hide?.includes(key)) {
                                             return (
                                               <Text key={index} style={styles.contentpart}>
                                                 <Text style={styles.boldLabel}>
                                                   {gmwcp_custom_field.label || ''}{' '}
                                                 </Text>
                                                 {gmwcp_custom_field.value || ''}{' '}
                                               </Text>
                                             );
                                           }
                                           return null; // Return null if the key is not included in `gmwcp_shop_show_hide`
                                         })
                                       }

                                       
                                {settings.setting?.gmwcp_shop_show_hide?.includes('attributes') && (
                                  <View style={styles.contentpart}>
                                    <Text style={styles.boldLabel}>{settings.setting?.gmpcp_trasnlation_attribute||''}{' '}</Text>
                                    {product.attributes && typeof product.attributes === 'object' && !Array.isArray(product.attributes) ? (
                                      Object.entries(product.attributes).map(([key, value], index) => (
                                        <Text key={index}>
                                          <Text style={styles.boldLabel}>{key}</Text>: {value}
                                        </Text>
                                      ))
                                    ) : (
                                      product.attributes.map((field, index) => (
                                        <Text key={index}>
                                          <Text style={styles.boldLabel}>{field.key}</Text>: {field.value}
                                        </Text>
                                      ))
                                    )}
                                  </View>
                                )}
                              </View>

                              {settings.setting?.gmwcp_shop_show_hide?.includes('long_desc') && (
                                <View >
                                  <Html>
                                       {`
                                          <style>
                                          h1,h2,h3,h4,h5,h6{
                                             margin:0;
                                             font-size:12px;
                                             margin-bottom:2px;
                                          }
                                          </style>
                                          <div style="font-size:12px; ">
                                             ${product.description}
                                          </div>
                                       `}
                                    </Html>
                                </View>
                              )}
                            </View>
                          ))}
                        </View>
 );